import { render } from "./WrapperView.vue?vue&type=template&id=10902264&scoped=true"
import script from "./WrapperView.vue?vue&type=script&lang=js"
export * from "./WrapperView.vue?vue&type=script&lang=js"

import "./WrapperView.vue?vue&type=style&index=0&id=10902264&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10902264"]])

export default __exports__